import {
  SET_ACT_PROPERTY,
  ACT_ERROR,
  SET_ACT_CHECKLIST_ITEM,
  UI_UPDATE_FROM_PARTNER
} from 'store/actions/act';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_ACT_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },
  [ACT_ERROR]: (state, error) => {
    state.error = error;
  },
  [UI_UPDATE_FROM_PARTNER]: (state, data) => {
    const { risk, checklists } = data;
    state.risk = risk;
    if (checklists && (!state.act || !state.act.checklists.length)) {
      checklists.forEach(checklist => {
        checklist.values.forEach(item => {
          // eslint-disable-next-line no-param-reassign
          item.value = item.value !== 0;
        });
      });
      state.checklists = checklists;
    }
  },
  [SET_ACT_CHECKLIST_ITEM]: (state, { checklistIndex, item, value }) => {
    const checklist = state.checklists[checklistIndex];
    checklist.values.forEach(checklistItemValue => {
      if (checklistItemValue.labelId === item) {
        // eslint-disable-next-line no-param-reassign
        checklistItemValue.value = value;
      }
    });
  }
};
